import TagSliderMixin from '@/components/mixins/tag-slider-mixin'
import EventBus from '@/components/mixins/event-bus-mixin'
import _ from 'lodash'
import CONST from '@/globals/constants'
import { mapActions, mapState } from 'pinia'
import { tagsStore } from '../../../pinia/stores/tagsStore'
import { selectionStore } from '../../../pinia/stores/selectionStore'
import { COMPONENT_KEY } from '../../../pinia/stores/storeUtils'

export default {
  name: 'ledTagsSlider',
  inject: [
    '$utils',
    '$apiError',
    '$filtersRepository'
  ],
  props: {
    ledTagsProp: {
      type: Array,
      default () { return [] }
    },
    tagsProp: {
      type: Array,
      default () { return [] }
    },
    popIdsProp: {
      type: Array,
      default () { return [] }
    },
    refilterLedTagsProp: {
      type: Object,
      default () { return { ref: null, prevFilterAction: '' } }
    },
    isVideowall: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(tagsStore, {
      tagsStoreError: 'error'
    }),
    ...mapState(selectionStore(COMPONENT_KEY.LED_SCREEN), {
      ledPageLedSelectionData: 'ledTags'
    }),
    ...mapState(selectionStore(COMPONENT_KEY.VIDEOWALL_SCREEN), {
      videowallPageVideowallSelectionData: 'videowallTags'
    }),
    selectedLedTags () {
      if (this.isVideowall) {
        return this.videowallPageVideowallSelectionData
      }

      return this.ledPageLedSelectionData
    }
  },
  watch: {
    ledTagsProp: {
      handler (newVal) {
        this.ledTags = newVal
        this.setDefaultData()
      },
      deep: true
    },
    tagsProp: {
      handler (newVal) {
        this.tags = newVal
        this.setDefaultData()
      },
      deep: true
    },
    popIdsProp: {
      handler (newVal) {
        this.popIds = newVal
        this.setDefaultData()
      },
      deep: true
    },
    refilterLedTagsProp (newVal) {
      if (!_.isEmpty(newVal.ref)) {
        this.setDefaultData()
      }
    }
  },
  mixins: [TagSliderMixin],
  data () {
    return {
      componentName: 'ledPageTagSlider',
      CONST,
      ledTags: this.ledTagsProp,
      tags: this.tagsProp,
      popIds: this.popIdsProp,
      selectedMediaTags: [],
      selectedPopIds: [],
      lockedLedTagsExpandAction: false
    }
  },
  methods: {
    ...mapActions(tagsStore, ['deleteTag']),
    ...mapActions(selectionStore(COMPONENT_KEY.LED_SCREEN), {
      ledPageUpdateLedSelectionStateData: 'updateLEDTagsSelection'
    }),
    ...mapActions(selectionStore(COMPONENT_KEY.VIDEOWALL_SCREEN), {
      videowallPageUpdateVideowallSelectionStateData: 'updateVideowallTagsSelection'
    }),
    emitEvent (action, data) {
      if (!_.isEmpty(action)) {
        _.delay(() => {
          this.$emit('led-tag-slider-change', { action, payload: { data } })
        }, 10)
      }
    },
    setDefaultData () {
      this.setFiltersFromRepository()
      this.$nextTick(_ => {
        this.$utils.updatePageComponentStyle({ name: 'ledPage' })
        this.updateLedTagsVisibilityPerMediaSelection()
        this.validateExpandIconVisibility()
      })

      /**
       * There are instances that the selected led tag is not visible by default, it depends on its index in the list.
       * Check if selected led tag is not visible, if so then expand the led slider by default.
       */
      if (this.selectedLedTags.length && this.selectedLedTags[0].startsWith('LED:')) {
        const dimension = this.selectedLedTags[0].substr(4)
        const ledTagSpanParents = $(`span:contains("${dimension}")`).parents()
        const ledTagItemWrapperEl = $(ledTagSpanParents[1])
        const ledTagSliderEl = $(ledTagSpanParents[4])

        window.setTimeout(() => {
          if ($(ledTagItemWrapperEl).hasClass('hide-while-draggging') && !$(ledTagSliderEl).hasClass('expanded')) {
            this.handleExpandComponentIconClick()
          }
        }, 50)
      }
    },
    setFiltersFromRepository () {
      if (this.isVideowall) {
        const selected = this.$filtersRepository.findVideowallTags().map(t => `LED:${t}`)
        this.videowallPageUpdateVideowallSelectionStateData(selected)
      } else {
        const selected = this.$filtersRepository.findLedTags().map(t => `LED:${t}`)
        this.ledPageUpdateLedSelectionStateData(selected)
      }

      this.selectedMediaTags = this.tags.filter(tag => this.$filtersRepository.findMediaTags().includes(tag.value))
      this.selectedPopIds = this.popIds.filter(popId => this.$filtersRepository.findPopIds().includes(popId.value))
    },
    setSelectedLedTags (ledTags = []) {
      const selectedTags = ledTags.map(l => l.replace('LED:', ''))

      if (this.isVideowall) {
        this.videowallPageUpdateVideowallSelectionStateData(ledTags)
        this.$filtersRepository.saveVideowallTags(selectedTags)
      } else {
        this.ledPageUpdateLedSelectionStateData(ledTags)
        this.$filtersRepository.saveLedTags(selectedTags)
      }
    },
    isTagSelected (tag) {
      const decodeTag = decodeURIComponent(tag)
      return this.selectedLedTags.includes(decodeTag) || this.selectedLedTags.includes(tag)
    },
    handleLedTagClick (tag) {
      // Do not unselect selected tag if currently selected
      if (this.isTagSelected(tag.value)) return

      this.setSelectedLedTags([tag.value])
      this.emitEvent(CONST.EMIT_EVENT_NEW_SELECTED_LED_TAG, this.selectedLedTags)
    },
    updateLedTagsVisibilityPerMediaSelection () {
      const newLedTags = this.$utils.clone(this.ledTags)

      // Hide led if there's no inline tag that will match in selected media tags or in popId
      for (const led of newLedTags) {
        const isSelectedMediaExistInInlineTags = this.selectedMediaTags.length && _.intersection(led.inline, this.selectedMediaTags.map(t => t.name)).length
        const isSelectedPopIdExistInLedTags = this.selectedPopIds.length && this.selectedPopIds[0].leds.filter((l) => l === led.name.replace('LED:', '')).length

        led._notVisible = !isSelectedMediaExistInInlineTags && !isSelectedPopIdExistInLedTags

        // All Led tags is visible if no filters
        if (!this.selectedMediaTags.length && !this.selectedPopIds.length) {
          led._notVisible = false
        }
      }

      this.ledTags = newLedTags
    },
    handleContentScrollY () {
      // Do not scroll if not expanded
      if (!this.expanded) {
        $(this.$refs.ledTagsSliderPresentation.ps.element).scrollTop(0)
      }
    },
    confirmDeleteTag (event, tag, indx) {
      // Send global event to show custom dialog
      EventBus.$emit('SHOW_CUSTOM_NOTIFICATION', {
        type: 'warning',
        title: this.$t('confirm.deleteCanvasResolution'),
        description: this.$t('led.deleteCanvasConfirmation'),
        alert: {
          message: this.$t('led.deleteCanvasWarning')
        },
        tag: {
          name: this.ledTags[indx].showLabel,
          color: '#DCDFE5'
        },
        callbacks: {
          eventOnClose: () => {},
          eventOKButtonClick: async () => {
            const deleteLedTagRequest = async () => {
              this.$utils.mainLoader(true)
              await this.deleteTag(tag, this.isVideowall ? 'videowall' : 'led')

              if (this.tagsStoreError) { this.$apiError.handleAPIRequestError(this.tagsStoreError, { originalRequest: () => { deleteLedTagRequest() }, showDialogNotification: true }) }

              // Send event to parent component
              this.emitEvent(CONST.EMIT_EVENT_DELETED_LED_TAG, {
                deletedLedTag: tag
              })
              this.$filtersRepository.deleteAll(true)
            }
            await deleteLedTagRequest(event, tag, indx)
          }
        }
      })
    }
  },
  mounted () {
    this.setDefaultData()
  }
}
